<template>
  <div id="confirmation-modal">
    <div class="text" v-html="text"></div>
    <div class="footer">
      <inline-link
        class="inline-link"
        :text="$t('confirmationModal.cancelButton')"
        @inlineLinkClicked="closeModal"
      />
      <rounded-button
        width="150px"
        buttonType="danger"
        position="right"
        @click="deleteClicked"
      >
        <div v-html="$t('confirmationModal.okButton')" />
      </rounded-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfirmationModal",
  props: {
    text: {
      type: String,
      required: true
    }
  },
  methods: {
    deleteClicked() {
      this.$eventBus.closeModal();
      this.$emit("okClicked");
    },
    closeModal() {
      this.$eventBus.closeModal();
    }
  }
};
</script>
<style lang="scss" scoped>
#confirmation-modal {
  padding: 20px;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  .text {
    text-align: center;
    line-height: 1.5;
    margin-bottom: 30px;
  }
  .footer {
    width: 100%;
    display: flex;
    align-items: center;
  }
}
</style>
